export var WhereOperator;
(function (WhereOperator) {
    WhereOperator["Equals"] = "=";
    WhereOperator["NotEquals"] = "!=";
    WhereOperator["GreaterThan"] = ">";
    WhereOperator["GreaterOrEqualThan"] = ">=";
    WhereOperator["LessThan"] = "<";
    WhereOperator["LessOrEqualThan"] = "<=";
    WhereOperator["In"] = "in";
    WhereOperator["NotIn"] = "nin";
})(WhereOperator || (WhereOperator = {}));
//# sourceMappingURL=where-clause.js.map